/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usually your TDEE for maintenance, or your TDEE minus a deficit for fat loss. Calculate it with the BMR & TDEE tool.`)
};

const es_macro_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalmente tu GEDT para mantenimiento, o tu GEDT menos un déficit para perder grasa. Calcúlalo con la herramienta de TMB y GEDT.`)
};

const de_macro_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der Regel deinen TDEE für den Erhalt oder deinen TDEE minus einem Defizit für den Fettabbau. Berechne ihn mit dem BMR- & TDEE-Tool.`)
};

const nl_macro_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meestal je TDEE voor onderhoud, of je TDEE min een tekort voor vetverlies. Bereken dit met de BMR & TDEE-tool.`)
};

const fr_macro_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Généralement votre TDEE pour le maintien, ou votre TDEE moins un déficit pour la perte de graisse. Calculez-le avec l'outil BMR & TDEE.`)
};

const it_macro_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di solito il tuo TDEE per il mantenimento, oppure il tuo TDEE meno un deficit per perdere grasso. Calcolalo con lo strumento BMR e TDEE.`)
};

const pt_br2_macro_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geralmente seu GET para manutenção, ou o GET menos um déficit para perda de gordura. Calcule com a ferramenta TMB e GET.`)
};

const pt_macro_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geralmente o seu TDEE para manutenção, ou o TDEE menos um défice para perda de gordura. Calcule-o com a ferramenta de TMB & TDEE.`)
};

const ja_macro_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常は維持カロリーとしてのTDEE、または脂肪減少のためにTDEEから不足分を引いた値です。基礎代謝・TDEE計算機で計算できます。`)
};

const zh_macro_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常是维持体重所需的 TDEE，或减脂时用 TDEE 减去热量缺口。可使用基础代谢率与 TDEE 计算器算出该数值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_faq_a4", locale)
	if (locale === "en") return en_macro_faq_a4(inputs)
	if (locale === "es") return es_macro_faq_a4(inputs)
	if (locale === "de") return de_macro_faq_a4(inputs)
	if (locale === "nl") return nl_macro_faq_a4(inputs)
	if (locale === "fr") return fr_macro_faq_a4(inputs)
	if (locale === "it") return it_macro_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_macro_faq_a4(inputs)
	if (locale === "pt") return pt_macro_faq_a4(inputs)
	if (locale === "ja") return ja_macro_faq_a4(inputs)
	return zh_macro_faq_a4(inputs)
};